import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "row mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SequenceOverview = _resolveComponent("SequenceOverview")
  const _component_AccountDetails = _resolveComponent("AccountDetails")
  const _component_SeqNoticeCard = _resolveComponent("SeqNoticeCard")
  const _component_EstoreTrans = _resolveComponent("EstoreTrans")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_SequenceOverview, { currencySymbol: _ctx.currency }, null, 8, ["currencySymbol"]),
    _createVNode(_component_AccountDetails),
    (_ctx.pcpmonitoring.congrats1 != undefined && _ctx.pcpmonitoring.congrats1 != null && _ctx.pcpmonitoring.congrats1 != '')
      ? (_openBlock(), _createBlock(_component_SeqNoticeCard, {
          key: 0,
          variant: "success",
          title: "Congratulations!",
          icon: "media/icons/duotone/General/GreenCheck.svg",
          class: "my-8"
        }, {
          default: _withCtx(() => [
            _createVNode("p", _hoisted_1, [
              _createTextVNode(_toDisplayString(_ctx.pcpmonitoring.congrats1) + " ", 1),
              _createVNode("b", null, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.pcpmonitoring.milestoneAmount).toFixed(2))) + " " + _toDisplayString(_ctx.currency), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.pcpmonitoring.congrats2) + " ", 1),
              _createVNode("b", null, _toDisplayString(_ctx.pcpmonitoring.unlockedUpgradePackage) + " Package!", 1)
            ]),
            _createVNode("button", {
              class: "btn btn-primary me-2",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pCPUpgradeConfirmation && _ctx.pCPUpgradeConfirmation(...args)))
            }, " Upgrade Now "),
            (_ctx.pcpmonitoring.nextMilestone != 0.00)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "btn btn-warning",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pCPMilestoneIgnoreConfirmation && _ctx.pCPMilestoneIgnoreConfirmation(...args)))
                }, " Not Now "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_EstoreTrans)
    ]),
    _createVNode(_component_router_view)
  ], 64))
}